   window.onclick = function() {
    let reset = document.querySelector('.reset23947hdfjue8934');
    let newDivSelect = reset.getElementsByTagName('div');
    let addAttribute = newDivSelect[7];
    addAttribute.setAttribute("onclick", "ga('send', 'event', 'Whatsapp Chat', 'Click')");    
   }   